import { useEffect } from "react";
import { ProfileForm } from "../components/profile/ProfileForm";
import { ChangePasswordForm } from "../components/profile/ChangePasswordForm";
import { useProfile } from "../hooks/useProfile";

export function SettingsProfilePage() {
  const { profile, isLoading, error, fetchProfile, updateProfile, uploadAvatar, deleteAvatar } =
    useProfile();

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Profile Settings</h1>

      <div className="bg-white rounded-lg shadow p-6 max-w-2xl">
        {error && !profile && (
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 mb-4">
            {error}
            <button
              onClick={fetchProfile}
              className="ml-4 text-sm underline hover:no-underline"
            >
              Try again
            </button>
          </div>
        )}

        {isLoading && !profile ? (
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <div className="w-20 h-20 rounded-full bg-gray-200 animate-pulse"></div>
              <div className="h-8 w-24 bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="h-10 bg-gray-200 rounded animate-pulse"></div>
            <div className="h-32 bg-gray-200 rounded animate-pulse"></div>
          </div>
        ) : (
          <ProfileForm
            profile={profile}
            isLoading={isLoading}
            onSave={updateProfile}
            onUploadAvatar={uploadAvatar}
            onDeleteAvatar={deleteAvatar}
          />
        )}

        <div className="mt-8 pt-8 border-t border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Security</h2>
          <ChangePasswordForm />
        </div>
      </div>
    </div>
  );
}
